export function initialize_cf7_success_view(block, options = {}) {
  if (!block || block.dataset.cf7SuccessInitialized === 'true') {
    return;
  }

  const {
    defaultSelector = '[data-cf7-success-default]',
    successSelector = '[data-cf7-success]',
    headingSelector = '[data-cf7-success-heading]',
    stateDataKey = 'cf7State',
  } = options;

  const defaultViews = Array.from(block.querySelectorAll(defaultSelector));
  const successView = block.querySelector(successSelector);

  if (!successView) {
    return;
  }

  const successHeading = successView.querySelector(headingSelector);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  block.addEventListener('wpcf7mailsent', (event) => {
    if (!(event.target instanceof Element) || !block.contains(event.target)) {
      return;
    }

    defaultViews.forEach((view) => {
      view.hidden = true;
    });

    successView.hidden = false;
    block.classList.add('is-submitted');
    block.dataset[stateDataKey] = 'success';

    const blockTop = block.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: blockTop,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });

    window.setTimeout(() => {
      successHeading?.focus({preventScroll: true});
    }, reducedMotion ? 0 : 550);
  });

  block.dataset.cf7SuccessInitialized = 'true';
}
